import {Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography} from "@mui/material";

interface IVideoPreset {
    config: any
    preset: string
}
export function VideoPreset({config, preset}: IVideoPreset) {
    return (
        <Accordion>
            <AccordionSummary>
                <Typography>{preset}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box display="flex">
                    <Typography sx={{flexGrow: 1}}><strong>Parent:</strong></Typography>
                    <Typography>{config.video_export.base.presets[preset].jsn_inherit}</Typography>
                </Box>
                <Divider/>
                {Object.keys(config.video_export.base.presets[preset])
                    .filter(key => key !== "jsn_inherit").map(setting =>
                        <Box display="flex" key={setting}>
                            <Typography sx={{flexGrow: 1}}><strong>{setting}:</strong></Typography>
                            <Typography>{config.video_export.base.presets[preset][setting].toString()}</Typography>
                        </Box>
                    )}
            </AccordionDetails>
        </Accordion>
    );
}